import { render, staticRenderFns } from "./reportManage.vue?vue&type=template&id=167be472&scoped=true&"
import script from "./reportManage.vue?vue&type=script&lang=js&"
export * from "./reportManage.vue?vue&type=script&lang=js&"
import style0 from "./reportManage.vue?vue&type=style&index=0&id=167be472&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167be472",
  null
  
)

export default component.exports